__turbopack_context__.v({
  "container": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__container",
  "cta": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__cta",
  "description": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__description",
  "desktopChart": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__desktopChart",
  "input": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__input",
  "inputs": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__inputs",
  "mobileChart": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__mobileChart",
  "suggestedPercentages": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__suggestedPercentages",
  "wrapper": "DKGavebrevTaxWidget-module-scss-module__t6AZ-q__wrapper",
});
